import { ready } from '@front/utils';
import { library, dom } from '@fortawesome/fontawesome-svg-core';

import {
    faGetPocket,
    faHackerNews,
    faLinkedinIn,
    faRedditAlien,
    faTumblr,
} from '@fortawesome/free-brands-svg-icons';

import {
    faEdit,
} from '@fortawesome/free-regular-svg-icons';

import {
    faAt,
    faEnvelope,
    faExclamation,
    faInfo,
    faFilePdf,
    faLocationDot,
    faMagnifyingGlass,
    faMinus,
    faPen,
    faPhone,
    faPlus,
    faPenNib,
    faTrash,
    faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faAt,
    faEdit,
    faEnvelope,
    faExclamation,
    faGetPocket,
    faInfo,
    faFilePdf,
    faHackerNews,
    faLinkedinIn,
    faLocationDot,
    faMagnifyingGlass,
    faMinus,
    faPen,
    faPhone,
    faPlus,
    faPenNib,
    faTrash,
    faTriangleExclamation,
    faTumblr,
    faRedditAlien,
);

ready(() => {
    dom.i2svg();
    dom.watch();
});
